export function isPartsSearch(searchMode) {
  return searchMode === 'BasicPartsSearch' || searchMode === 'NestedConfigPartsSearch';
}
